const initialize = `
  mutation initializeTransaction($input: initializeTransactionInput!){
    initializeTransaction(input: $input){
      errors
      value {
        transactionId
      }
    }
  }
`;

const process = `
  mutation processTransaction($transactionId: String!, $input: processTransactionInput!){
    processTransaction(transactionId: $transactionId, input: $input) {
      errors
      status
    }
  }
`;

const tokenQuery = `
query transactionToken($tenantId: String!, $clientId: String!, $username: String!, $password: String!){
  token_2(tenantId: $tenantId,
    clientId: $clientId,
    username: $username,
    password: $password){
      accessToken
      error
  }
}  
`;

const mutation = {
  initialize,
  process
};

const query = {
  tokenQuery
};

export { mutation, query };



// WEBPACK FOOTER //
// ./src/lib/query.js